"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayCardWithUser = void 0;
var _button = require("@clayui/button");
var _dropDown = require("@clayui/drop-down");
var _form = require("@clayui/form");
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _layout = _interopRequireDefault(require("@clayui/layout"));
var _sticker = _interopRequireDefault(require("@clayui/sticker"));
var _react = _interopRequireDefault(require("react"));
var _Card = _interopRequireDefault(require("./Card"));
var _excluded = ["aria-label", "actions", "checkboxProps", "description", "disabled", "dropDownTriggerProps", "href", "name", "onSelectChange", "selected", "spritemap", "stickerTitle", "selectableType", "radioProps", "userImageAlt", "userDisplayType", "userImageSrc", "userSymbol", "truncate"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
/**
 * Different types of props depending on selectableType.
 *
 * onSelectChange: callback for when item is selected
 * selectableType: determines what type of selectable it is
 */

var ClayCardWithUser = exports.ClayCardWithUser = function ClayCardWithUser(_ref) {
  var ariaLabel = _ref['aria-label'],
    actions = _ref.actions,
    _ref$checkboxProps = _ref.checkboxProps,
    checkboxProps = _ref$checkboxProps === void 0 ? {} : _ref$checkboxProps,
    description = _ref.description,
    disabled = _ref.disabled,
    _ref$dropDownTriggerP = _ref.dropDownTriggerProps,
    dropDownTriggerProps = _ref$dropDownTriggerP === void 0 ? {
      'aria-label': 'More actions'
    } : _ref$dropDownTriggerP,
    href = _ref.href,
    name = _ref.name,
    onSelectChange = _ref.onSelectChange,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    spritemap = _ref.spritemap,
    stickerTitle = _ref.stickerTitle,
    selectableType = _ref.selectableType,
    _ref$radioProps = _ref.radioProps,
    radioProps = _ref$radioProps === void 0 ? {
      name: '',
      value: ''
    } : _ref$radioProps,
    _ref$userImageAlt = _ref.userImageAlt,
    userImageAlt = _ref$userImageAlt === void 0 ? 'thumbnail' : _ref$userImageAlt,
    userDisplayType = _ref.userDisplayType,
    userImageSrc = _ref.userImageSrc,
    _ref$userSymbol = _ref.userSymbol,
    userSymbol = _ref$userSymbol === void 0 ? 'user' : _ref$userSymbol,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? true : _ref$truncate,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var content = /*#__PURE__*/_react.default.createElement("div", {
    className: "aspect-ratio-item-center-middle card-type-asset-icon"
  }, /*#__PURE__*/_react.default.createElement(_sticker.default, {
    className: "sticker-user-icon",
    displayType: userDisplayType,
    shape: "circle",
    title: stickerTitle
  }, userImageSrc && /*#__PURE__*/_react.default.createElement(_sticker.default.Image, {
    alt: userImageAlt,
    src: userImageSrc
  }), !userImageSrc && /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: userSymbol
  })));
  return /*#__PURE__*/_react.default.createElement(_Card.default, _extends({}, otherProps, {
    active: selected,
    displayType: "user",
    selectable: !!onSelectChange
  }), /*#__PURE__*/_react.default.createElement(_Card.default.AspectRatio, {
    className: "card-item-first"
  }, onSelectChange && (selectableType === 'radio' ? /*#__PURE__*/_react.default.createElement(_form.ClayRadio, _extends({}, radioProps, {
    checked: selected,
    disabled: disabled,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onSelectChange(value);
    }
  }), content) : /*#__PURE__*/_react.default.createElement(_form.ClayCheckbox, _extends({}, checkboxProps, {
    checked: selected,
    disabled: disabled,
    onChange: function onChange() {
      return onSelectChange(!selected);
    }
  }), content)), !onSelectChange && content), /*#__PURE__*/_react.default.createElement(_Card.default.Body, null, /*#__PURE__*/_react.default.createElement(_Card.default.Row, null, /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
    expand: true
  }, /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : name,
    disabled: disabled,
    displayType: "title",
    href: href,
    truncate: truncate
  }, name), description && /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    displayType: "subtitle",
    truncate: truncate
  }, description)), actions && /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, null, /*#__PURE__*/_react.default.createElement(_dropDown.ClayDropDownWithItems, {
    items: actions,
    spritemap: spritemap,
    trigger: /*#__PURE__*/_react.default.createElement(_button.ClayButtonWithIcon, _extends({}, dropDownTriggerProps, {
      className: "component-action",
      disabled: disabled,
      displayType: "unstyled",
      spritemap: spritemap,
      symbol: "ellipsis-v"
    }))
  })))));
};